import React from "react";
import { Chip, Typography } from "@mui/material";

function formatDate(value) {
    if (!value) return "—";
    const raw = String(value);
    const datePart = raw.includes("T") ? raw.split("T")[0] : raw.slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return raw;
    const [y, m, d] = datePart.split("-");
    return `${d}/${m}/${y}`;
}

function isExpired(expireAt) {
    if (!expireAt) return false;
    const raw = String(expireAt);
    const datePart = raw.includes("T") ? raw.split("T")[0] : raw.slice(0, 10);
    const today = new Date().toISOString().slice(0, 10);
    return datePart < today;
}

export const PromocodeColumns = () => [
    {
        id: "code",
        label: "Code",
        render: (value, row) => (
            <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: "monospace" }}>
                {row.code || "—"}
            </Typography>
        ),
    },
    {
        id: "discount",
        label: "Discount",
        render: (value, row) => (
            <Typography variant="body2">{row.discount != null ? `${row.discount}%` : "—"}</Typography>
        ),
    },
    {
        id: "expire_at",
        label: "Expires",
        render: (value, row) => {
            const expired = isExpired(row.expire_at);
            return (
                <Chip
                    size="small"
                    color={expired ? "default" : "success"}
                    label={formatDate(row.expire_at) + (expired ? " (expired)" : "")}
                    variant={expired ? "outlined" : "filled"}
                />
            );
        },
    },
    {
        id: "used",
        label: "Used",
        render: (value, row) => (
            <Typography variant="body2">{row.used ?? 0}</Typography>
        ),
    },
    {
        id: "max_usage",
        label: "Max usage",
        render: (value, row) => (
            <Typography variant="body2">{row.max_usage != null ? row.max_usage : "—"}</Typography>
        ),
    },
    {
        id: "created_at",
        label: "Created",
        render: (value, row) => (
            <Typography variant="body2" color="text.secondary">
                {formatDate(row.created_at)}
            </Typography>
        ),
    },
];
